import { Page } from 'layouts/Page';
import { FC } from 'react';
import { GpsrProductTypes } from 'components/GpsrProductTypes';
import { GpsrInvoicesList } from 'components/GpsrInvoicesList';

export const GpsrInvoicesPage: FC = () => {
	return (
		<Page title="GPSR Management – EAS Control Center">
			<GpsrInvoicesList />
		</Page>
	);
};
